import React from 'react'
import PropTypes from 'prop-types'
import {
  Description,
  DescriptionWrapper,
  LeftBoxWrapper,
  StyledHeaderTwo,
  Users,
} from './component.styles'

const LeftBox = ({ description, showDescription, title, usersCount }) => (
  <LeftBoxWrapper>
    <StyledHeaderTwo>{title}</StyledHeaderTwo>
    {showDescription && (
      <DescriptionWrapper>
        <Users>{usersCount}</Users> Users •{' '}
        <Description>{description}</Description>
      </DescriptionWrapper>
    )}
  </LeftBoxWrapper>
)

LeftBox.propTypes = {
  description: PropTypes.string,
  showDescription: PropTypes.bool,
  title: PropTypes.string,
  usersCount: PropTypes.number,
}

export default LeftBox
